import { debounce } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';

import * as actions from './investmentSymbolsActions';
import { mkInvestmentSymbol } from './investmentSymbolsTypes';

export function* getInvestmentSymbolsActionWatcher() {
  const config = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'investment symbols lookup',
    resourceBaseUrl: '/v2/investments/symbol-lookup',
    getLastSyncDate: null,
    transformResponseToResources: (response) =>
      response.data?.results?.map((item) => mkInvestmentSymbol({ id: item.symbol, ...item })),
    successAction: actions.getInvestmentSymbolsSuccess,
    failureAction: actions.getInvestmentSymbolsFailure,
    axiosConfig: { params: { limit: 50 } },
  });
  yield debounce(400, actions.getInvestmentSymbols, resourceSagaUtils.qcsSyncGetResources, config);
}

export default [getInvestmentSymbolsActionWatcher];
